import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/stop-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM56 256c0 110.5 89.5 200 200 200s200-89.5 200-200-89.5-200-200-200-200 89.5-200 200zM352 176v160c0 8.8-7.2 16-16 16h-160c-8.8 0-16-7.2-16-16v-160c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/stop-circle.js
// module id = 1821
// module chunks = 0